import { ApiClient } from "@/api-client/src/core/api-client";
import { CurrencyResponse } from "@/packages/types/currency";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchAllCurrencies = async (): Promise<CurrencyResponse> => {
  const response = await webService.get<CurrencyResponse>(`/currencies`);
  return response;
};
